module.exports = __webpack_public_path__ + "static/img/Martin-Boyle.d270cee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Martin-Boyle.jpg
// module id = wIf1
// module chunks = 0